import TitleBarComponent from './TitleBar.vue';
export const TitleBar = TitleBarComponent;
export default TitleBar;
